import { GraphQLErrors } from '@apollo/client/errors'
import { useCallback } from 'react'
import { CustomerDetailFragment, useCustomerNewMutation, useCustomerUpdateMutation } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'
import { CustomerFormData, getCustomerInput } from './form/customer.form.types'

export type CustomerResult =
  | {
      type: 'SUCCESS'
      customer: CustomerDetailFragment
    }
  | {
      type: 'FAIL'
      errors?: GraphQLErrors
    }

export default function useCustomerApi() {
  const tenant = useTenant()
  const [createM] = useCustomerNewMutation()
  const [updateM] = useCustomerUpdateMutation({ refetchQueries: ['Documents'] })

  const create = useCallback(
    async (customerData: CustomerFormData): Promise<CustomerResult> => {
      try {
        const result = await createM({ variables: { input: getCustomerInput(customerData, tenant.id) }, refetchQueries: ['Customers'] })
        const customer = result.data?.createCustomer
        if (!customer) {
          return { type: 'FAIL', errors: result.errors }
        }
        return { type: 'SUCCESS', customer }
      } catch (e) {
        return { type: 'FAIL' }
      }
    },
    [tenant.id, createM],
  )

  const update = useCallback(
    async (customerId: string, customerData: CustomerFormData, guestOfReservedResourceId?: string): Promise<CustomerResult> => {
      try {
        const result = await updateM({ variables: { id: customerId, input: getCustomerInput(customerData, tenant.id), guestOfReservedResourceId: guestOfReservedResourceId } })
        const customer = result.data?.updateCustomer
        if (!customer) {
          return { type: 'FAIL', errors: result.errors }
        }
        return { type: 'SUCCESS', customer: customer }
      } catch (e) {
        return { type: 'FAIL' }
      }
    },
    [tenant.id, updateM],
  )
  return { create, update }
}
